import React, { useState, useRef } from "react";
import {
  StyleSheet,
  Text,
  View,
  TextInput,
  Pressable,
  Platform,
} from "react-native";

function OneTimeCode({
  codeLength = 4,
  checkCode,
  onFill = () => {},
  disabled = false,
}) {
  const [code, setCode] = useState("");
  const [containerIsFocused, setContainerIsFocused] = useState(false);

  const codeDigitsArray = new Array(codeLength).fill(0);

  let ref = useRef(null);

  const handleOnPress = () => {
    setContainerIsFocused(true);
    ref?.current?.focus();
  };

  const handleOnBlur = () => {
    setContainerIsFocused(false);
    if (code && checkCode && code == checkCode) {
      onFill(null, { success: "code matched" });
    } else {
      onFill({ error: "code not matched" });
    }
  };

  const toDigitInput = (_value, idx) => {
    const emptyInputChar = " ";
    const digit = code[idx] || emptyInputChar;

    const isCurrentDigit = idx === code.length;
    const isLastDigit = idx === codeLength - 1;
    const isCodeFull = code.length === codeLength;

    const isFocused = isCurrentDigit || (isLastDigit && isCodeFull);

    const containerStyle =
      containerIsFocused && isFocused
        ? { ...style.inputContainer, ...style.inputContainerFocused }
        : style.inputContainer;

    return (
      <View key={idx} style={containerStyle}>
        <Text style={style.inputText}>{digit}</Text>
      </View>
    );
  };

  return (
    <View style={style.container}>
      <Pressable style={style.inputsContainer} onPress={handleOnPress}>
        {codeDigitsArray.map(toDigitInput)}
      </Pressable>
      <TextInput
        ref={ref}
        editable={!disabled}
        value={code}
        onChangeText={setCode}
        onSubmitEditing={handleOnBlur}
        keyboardType="number-pad"
        returnKeyType="done"
        textContentType="oneTimeCode"
        maxLength={codeLength}
        style={[
          style.hiddenCodeInput,
          Platform.OS === "web" ? { outline: 0 } : {},
        ]}
      />
    </View>
  );
}

const style = StyleSheet.create({
  container: {
    margin: 5,
    justifyContent: "center",
    alignItems: "center",
  },
  inputsContainer: {
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-around",
  },
  inputContainer: {
    borderColor: "#cccccc",
    borderBottomWidth: 2,
    borderRadius: 4,
    paddingHorizontal: 12,
  },
  inputContainerFocused: {
    borderColor: "#0f5181",
  },
  inputText: {
    fontSize: 24,
    fontFamily: "Menlo-Regular",
  },
  hiddenCodeInput: {
    position: "absolute",
    height: 0,
    width: 0,
    opacity: 0,
  },
});

export default OneTimeCode;
